import script from "./MenuBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuBtn.vue?vue&type=script&setup=true&lang=ts"

import "./MenuBtn.vue?vue&type=style&index=0&id=2be7d814&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be7d814"]])

export default __exports__